import React from "react";
import { SlHome } from "react-icons/sl";
import { BreadCrumbContainer } from "./BreadCrumbContainer";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetPhoneNo } from "../../../store/Contact/phoneNoSlice";
import { resetAnalyticsData } from "../../../store/index";

interface BreadCrumbComponent {
  type?: string
  subType?: string
  subTypeClickable?: boolean
  typeLink?: string
  subTypeLink?: string
}
const BreadCrumbComponent : React.FC<BreadCrumbComponent> = ({ type, subType, subTypeClickable, typeLink, subTypeLink }) => {
  const navigate = useNavigate();
  const params = useParams();
  const contactType = useSelector((state : any) => state.contactType);
  const dispatch = useDispatch();

  return (
    <BreadCrumbContainer>
      <a className="home-icon" href={"/"}>
        <SlHome color="gray" size={16} />
      </a>
      <div className="mx-2">|</div>
      <div
        className="name-link"
        onClick={() => {
          dispatch(resetPhoneNo());
          dispatch(resetAnalyticsData());
          navigate(typeLink || "/reactcontact");
        }}
      >
        {type}
      </div>
      {subType && <div className="mx-1">-</div>}
      <div
        className="name-link"
        onClick={() => {
          if (subTypeClickable) {
            dispatch(resetPhoneNo());
            dispatch(resetAnalyticsData());
            navigate(subTypeLink || `/reactcontact/${contactType}/${params.contactId}`);
          }
        }}
      >
        {subType}
      </div>
    </BreadCrumbContainer>
  );
};

export default BreadCrumbComponent;
